export default "__VITE_ASSET__Bdl0Dheq__"